import React, { useState, useEffect } from 'react';
import { getVenueWithSearch, getVenue } from '../isdlData/countryData';
import { Pagination, Box } from '@mui/material';
import { MinimizeIcon1 } from '../icons/Icons';
import AsyncSelect from 'react-select/async';

const ITEMS_PER_PAGE = 10; // Define how many items you want per page

function VenueList({dbInitialized, VenueChanged, LoadedVenue}){

    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [error, setError] = useState('');
    const [selectedVenue, setSelectedVenue] = useState(null);
    const [items, setItems] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [paginatedItems, setPaginatedItems] = useState([]);

    useEffect(() => {

        setLoading(!dbInitialized);

        return () => {
            //cleanup here
        };
    },[dbInitialized]);

    useEffect(() => {

        async function PrefillVenue(){

            const venue = (await getVenue("USA", LoadedVenue));
            setSelectedVenue(formatVenueData(venue));
            VenueChanged(venue);
        }

        if(dbInitialized && (LoadedVenue !== undefined && LoadedVenue !== null && LoadedVenue !== '')){
            PrefillVenue();
        }

    }, [LoadedVenue]);

const handleVenueChange = () => {
    VenueChanged(selectedVenue);
};

const handleVenueSearch = async () =>{
    if(searchTerm.length === 0){
        setError('Please input a search term for venues.');
        setPage(1);
        setItems([]);
        return;
    }

    setError('');
    //setSelectedVenue(null); // Reset selected item
    setPage(1); // Reset page when making a new search
    setItems([]);

    try{
        const venues = await getVenueWithSearch('USA', searchTerm);
        const result = Array.isArray(venues) ? venues : [venues];

        if(result.length === 0){
            setError(`No venues found with the name '${searchTerm}'`);
        }
        else if(result.length === 1){
            setSelectedVenue(result[0]);
            VenueChanged(result[0]);
        } else {
            //show list
            setItems(result);
            setTotalPages(Math.ceil(result.length / ITEMS_PER_PAGE));
            handlePagenatedItems(result, 1);
        }


    } catch(ex){
        setError('Error fetching venues.');
    }
};

const handleVenueKeyDown = (e) => {
    if (e.key === 'Enter') {
        e.preventDefault();
        handleVenueSearch();
      }
}

const handleConfirm = () => {
    if (selectedVenue) {
      console.log(`Confirmed item: ${selectedVenue.Name}`);
    }
  };

const handlePageChange = (event, value) => {
    setPage(value);
    handlePagenatedItems(items, value);
};

function handlePagenatedItems(fullItems, pageNum)
{
    const filteredItems = fullItems.slice(
        (pageNum - 1) * ITEMS_PER_PAGE,
        pageNum * ITEMS_PER_PAGE
    );
    setPaginatedItems(filteredItems);
}

const handleCollapseList = () => {
    setPage(1); // Reset page when making a new search
    setItems([]);
    setPaginatedItems([]);
}

const handleSelectVenue = (venue) =>{

    if(venue){
        const data = venue.data;
        setSelectedVenue(venue);
        VenueChanged(data);
    }else{
        setSelectedVenue(null);
        VenueChanged(null);
    }
}

const loadOptions = async (inputValue) => {
    if (inputValue.length < 1) return []; // Only search if input has 3 or more characters
    const results = await getVenueWithSearch('USA', inputValue); // Call your async search function
    const venues = Array.isArray(results) ? results : [results];
    return venues.map(venue => ({
      value: venue.Name,
      label: venue.Name,
      data: venue, // Attach full user data here for easy retrieval
    }));
  };

  function formatVenueData(venue){
    return {
        value: venue.Name,
        label: venue.Name,
        data: venue, 
    }
}

    return(
<div>
    <div style={{display:'flex', flexDirection:'row', margin:'10px'}}>
        <div style={{flex:'1', marginRight:'10px'}}>
            <AsyncSelect
                    id="venueSelector"
                    cacheOptions
                    loadOptions={loadOptions}
                    defaultOptions
                    placeholder="Search for a venue"
                    isClearable
                    value={selectedVenue} 
                    onChange={handleSelectVenue}
                    classNamePrefix='search-input'
                    styles={{
                        option: (base, { isFocused, isSelected }) => ({
                        ...base,
                            backgroundColor: isFocused || isSelected ? getComputedStyle(document.documentElement).getPropertyValue('--selected-highlight') : getComputedStyle(document.documentElement).getPropertyValue('--input-background'),
                            color: isFocused || isSelected ? getComputedStyle(document.documentElement).getPropertyValue('--input-background') : getComputedStyle(document.documentElement).getPropertyValue('--input-foreground'),
                        }),
                    }}
                    />
        </div>
    
        {/* <input
            className='venue-search-input'
            style={{flex:'1', marginRight:'10px'}}
            type="search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyDown={handleVenueKeyDown}
            placeholder='Search Venues'
            disabled={loading}/>
            <button 
                onClick={handleVenueSearch} 
                disabled={loading} 
                className='venue-search-button' 
                style={{width:'100px', flex:'0 0 auto'}}>Search</button> */}

        {/* {selectedVenue && (
            <div className='venue-selected-div'>
                Venue Selected: {selectedVenue.Name}
            </div>
        )}

        {!selectedVenue && (
            <div className='venue-selected-div'>
                No venue selected.
            </div>
        )} */}

        {/* {paginatedItems.length > 1 && (
            <button
            style={{width:'40px', marginLeft:'auto', background:'transparent', border:'0px'}}
            onClick={handleCollapseList}>
                <MinimizeIcon1/>
            </button>
        )} */}

    </div>

    {/* {items.length > 1 && (
        <div>
            {paginatedItems.map((item) => (
                <div key={item.Name}>
                <input
                    className='venue-item'
                    type="button"
                    name="selectedItem"
                    value={item.Name}
                    disabled={selectedVenue ? item.Name === selectedVenue.Name : false}
                    onClick={() => handleSelectVenue(item)}
                />
                </div>
            ))}
            
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
            <Pagination
                count={totalPages}
                page={page}
                onChange={handlePageChange}
                color="primary"
                variant='outlined'
                sx={{
                    "& .MuiPaginationItem-root": {
                      color: getComputedStyle(document.documentElement).getPropertyValue('--foreground-primary'),  // Set text color to white
                    },
                  }}
            />
            </Box>
        </div>
    )} */}

    {error && <div>{error}</div>}

</div>
    );
}

export default VenueList;
